import { idaman } from '../config';
import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

export const oidcConfig = {
  authority: idaman.OIDC_AUTHORITY,
  client_id: idaman.OIDC_CLIENT_ID,
  client_secret: idaman.OIDC_CLIENT_SCR,
  redirect_uri: idaman.OIDC_REDIRECT_URI,
  post_logout_redirect_uri: idaman.OIDC_LOGOUT_URI,
  response_type: 'code',
  scope: 'openid profile email',
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
};

export const userManager = new UserManager({
  ...oidcConfig,
  // localStorage, sama dengan penyimpanan sesi Hydro (redux-persist): sesi dibagi antar tab.
  // id_token tidak tertinggal lama: BE memutus sesi idle 15 menit dan forceLogout memanggil removeUser().
  userStore: new WebStorageStateStore({ store: window.localStorage }),
});
